import React from "react";
import { IconButton, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

import { styled } from "@mui/material/styles";
import WebMAPToolTip from "components/WebMAPToolTip";

const StyledPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  minWidth: "unset",
}));

/**
 * @summary Resets map to initial zoom level, centrum coordinate and active layers.
 *
 * @param {object} props
 * @returns {object} React
 */
class MapResetter extends React.PureComponent {
  // TODO: Also reset layers to default visibility!
  handleClick = (e) => {
    const { map } = this.props;
    if (map !== undefined) {
      const view = map.getView();
      const { zoom, center } = this.props.mapConfig.map;
      view.animate({ zoom, center });
    }
  };

  render() {
    return (
      <WebMAPToolTip title="Връщане на картата в първоначално състояние">
        <StyledPaper>
          <StyledIconButton
            aria-label="Връщане на картата в начално състояние"
            onClick={this.handleClick}
          >
            <HomeIcon />
          </StyledIconButton>
        </StyledPaper>
      </WebMAPToolTip>
    );
  }
}

export default MapResetter;
